export const convertNumberToPercentages = (value) => {
  const percentagesValue = Number(value) * 100;

  return percentagesValue;
};
